import type { TemplateYaml, TemplatePushBody } from '@wayai/core/contracts';

/**
 * Build the locale-agnostic `common` block of a template push from a parsed
 * `template.yaml`. Kept pure (no fs / auth / network) so the manifest → wire mapping is
 * unit-testable on its own — in particular the `uses` channel→backend edge (gh #2955)
 * that the store persists and the website derives its cross-link from. Driving the whole
 * `runTemplatePush` command instead would need an fs + auth harness, and reverting the
 * mapping there would otherwise leave every test green.
 */
export function buildTemplatePushCommon(
  manifest: TemplateYaml,
  hero?: TemplatePushBody['common']['hero'],
): TemplatePushBody['common'] {
  return {
    category: manifest.category,
    tags: manifest.tags,
    status: manifest.status,
    order: manifest.order ?? 0,
    installCommand: manifest.wayai.installCommand,
    ...(hero && { hero }),
    // The channel→backend edge (locale-agnostic). The store persists it verbatim; the
    // website derives the "runs on backend X" cross-link + MCP endpoint from the slugs.
    uses: manifest.uses,
  };
}
